module.exports = __webpack_public_path__ + "static/Solution_Ad6-d8c2befe7e75a1c2e03ad61e80ba7919.png";